import React from "react";
import { Link } from "react-router-dom";
import { Box, Container, Typography, IconButton, Grid2 } from "@mui/material";
import Facebook from "@mui/icons-material/Facebook";
import Instagram from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { fonts, headingFonts, noOutline } from "../../Styles/Styles";

const Footer = () => {
  return (
    <>
      <Box
        component="footer"
        sx={{ bgcolor: "#EBEEEF", color: "#212529", pt: 5, pb: 3 }}
      >
        <Container maxWidth="lg">
          <Grid2 container spacing={4}>
            {/* About Section */}
            <Grid2 item size={{ xs: 12, md: 4 }}>
              <Link to="/" style={{ textDecoration: "none" }}>
                <img
                  src="/Listed.ky-Logo-clipped.png"
                  alt="Logo"
                  style={{
                    width: "120px",
                    marginRight: "16px",
                    marginBottom: "10px",
                  }}
                />
              </Link>
              <Typography variant="body2" color="#212529" sx={{ ...fonts }}>
                Welcome to our platform, your number one source for buying and
                selling in Cayman Islands. We're dedicated to providing you the
                best experience, focusing on quality, security, and customer
                support.
              </Typography>
            </Grid2>

            {/* Quick Links Section */}
            <Grid2 item size={{ xs: 12, md: 4 }}>
              <Typography
                variant="h6"
                sx={{
                  ...headingFonts,
                  mb: 2,
                  color: "var(--primary-color)",
                }}
              >
                Quick Links
              </Typography>
              <Box>
                <Link
                  to="https://blog.listed.ky/"
                  onClick={() => window.scrollTo(0, 0)} // Scroll to top on link click
                  style={{
                    color: "#212529",
                    display: "block",
                    textDecoration: "none",
                  }}
                >
                  Blog
                </Link>
                <Link
                  to="/about"
                  onClick={() => window.scrollTo(0, 0)} // Scroll to top on link click
                  style={{
                    color: "#212529",
                    display: "block",
                    textDecoration: "none",
                  }}
                >
                  About Us
                </Link>
                <Link
                  to="/contact"
                  onClick={() => window.scrollTo(0, 0)} // Scroll to top on link click
                  style={{
                    color: "#212529",
                    display: "block",
                    textDecoration: "none",
                  }}
                >
                  Contact Us
                </Link>
                <Link
                  to="/terms"
                  onClick={() => window.scrollTo(0, 0)} // Scroll to top on link click
                  style={{
                    color: "#212529",
                    display: "block",
                    textDecoration: "none",
                  }}
                >
                  Terms of Service
                </Link>
                <Link
                  to="/privacy"
                  onClick={() => window.scrollTo(0, 0)} // Scroll to top on link click
                  style={{
                    color: "#212529",
                    display: "block",
                    textDecoration: "none",
                  }}
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/disclaimer"
                  onClick={() => window.scrollTo(0, 0)} // Scroll to top on link click
                  style={{
                    color: "#212529",
                    display: "block",
                    textDecoration: "none",
                  }}
                >
                  Disclaimer
                </Link>
              </Box>
            </Grid2>

            {/* Contact Section */}
            <Grid2 item size={{ xs: 12, md: 4 }}>
              <Typography
                variant="h6"
                sx={{
                  ...headingFonts,
                  mb: 2,
                  color: "var(--primary-color)",
                }}
              >
                Contact Us
              </Typography>
              <Link
                to="mailto:info@listed.ky"
                style={{
                  color: "#212529",
                  display: "block",
                  textDecoration: "none",
                }}
              >
                info@listed.ky
              </Link>
              <Box sx={{ mt: 2 }}>
                <IconButton
                  href="https://www.facebook.com/profile.php?id=61572445648724"
                  target="_blank"
                  sx={{ ...noOutline }}
                >
                  <Facebook sx={{ color: "var(--primary-color)" }} />
                </IconButton>
                <IconButton
                  href="https://www.instagram.com/listed.ky/"
                  target="_blank"
                  sx={{ ...noOutline }}
                >
                  <Instagram sx={{ color: "var(--primary-color)" }} />
                </IconButton>
                <IconButton
                  href="https://www.linkedin.com/company/listed-ky"
                  target="_blank"
                  sx={{ ...noOutline }}
                >
                  <LinkedInIcon sx={{ color: "var(--primary-color)" }} />
                </IconButton>
              </Box>
            </Grid2>
          </Grid2>
        </Container>
      </Box>

      {/* Footer Bottom */}
      <Box
        sx={{
          py: 2,
          textAlign: "center",
          backgroundColor: "var(--secondary-color)",
        }}
      >
        <Typography variant="body2" color="white" sx={{ ...headingFonts }}>
          &copy; {new Date().getFullYear()} Listed.ky. All Rights Reserved.
        </Typography>
      </Box>
    </>
  );
};

export default Footer;
